import { Box, CircularProgress, Typography } from '@mui/material'
import { lazy, Suspense } from 'react'
import { createBrowserRouter, Outlet } from 'react-router-dom'

import Background from './components/common/Background.tsx'
import ErrorPage from './components/common/ErrorPage.tsx'

import Dashboard from './components/dashboard/index.tsx'
import WellcomePage from './components/login/WellcomePage.tsx'
import Login from './components/login/index.tsx'
import Profile from './components/profile/index.tsx'
import Settings from './components/settings/index.tsx'
import Vacancies from './components/vacancies/index.tsx'
import Viewer from './components/viewer/index.tsx'

const VacancyExplorer = lazy(() => import('./components/vacancyExplorer/index.tsx'))
const Vacancy = lazy(() => import('./components/vacancies/Vacancy.tsx'))
const Landing = lazy(() => import('./components/landing/Landing.tsx'))
const Gdpr = lazy(() => import('./components/common/Gdpr.tsx'))
const Proxy = lazy(() => import('./components/common/Proxy'))

const BackgroundLayout = () => (
  <Background>
    <Outlet />
  </Background>
)

const GlobalLoader = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100%',
      bgcolor: 'rgba(255, 255, 255, 0.8)',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 9999,
    }}
  >
    <CircularProgress size={60} thickness={4} sx={{ color: '#1976d2', mb: 2 }} />
    <Typography
      variant='body1'
      sx={{
        fontWeight: 600,
        color: '#555',
        letterSpacing: '1px',
      }}
    >
      LOADING...
    </Typography>
  </Box>
)

export default createBrowserRouter([
  {
    element: (
      <Suspense fallback={<GlobalLoader />}>
        <Outlet />
      </Suspense>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        element: <BackgroundLayout />,
        children: [
          { path: '/', element: <WellcomePage /> },
          { path: '/login', element: <Login /> },
          { path: '/dashboard', element: <Dashboard /> },
          { path: '/viewer', element: <Viewer /> },
          { path: '/settings', element: <Settings /> },
          { path: '/vacancies', element: <Vacancies /> },
          { path: '/profile/:id?', element: <Profile /> },
        ],
      },

      {
        children: [
          { path: '/vacancy-explorer/:category?', element: <VacancyExplorer /> },
          { path: '/vacancy/:id', element: <Vacancy /> },
          { path: '/landing', element: <Landing /> },
          { path: '/gdpr', element: <Gdpr /> },
          { path: '/proxy', element: <Proxy /> },
        ],
      },
    ],
  },
])
